import { render, staticRenderFns } from "./HolidayPlusHotels.vue?vue&type=template&id=ffeebbfe"
import script from "./HolidayPlusHotels.vue?vue&type=script&lang=js"
export * from "./HolidayPlusHotels.vue?vue&type=script&lang=js"
import style0 from "./HolidayPlusHotels.vue?vue&type=style&index=0&id=ffeebbfe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports